import React from "react"
import { createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider } from "react-router-dom"
import { GoogleReCaptchaContextProvider } from "../components/captcha/google-recaptcha-context"
import { BSLayout } from "../components/layout/BSLayout"
import Layout from "../components/layout/layout"
import LayoutAdmin from "../components/layout/layoutAdmin"
import { NotificationContextProvider } from "../components/notifications/NotificationContext"
import RequireAuth from "../components/redirect/require-auth"
import RequireAuthUltimate from "../components/redirect/require-auth-ultimate"
import { RequireNoAuth } from "../components/redirect/require-no-auth"
import RequireOrganization from "../components/redirect/require-organization"
import { adminPagesUrl, pagesUrl } from "../core/appConstants"
import { AppSideBarContextProvider } from "../core/context/AppSideBarContext/AppSideBarContext"
import { DepartmentContextProvider } from "../core/context/DepartmentContext"
import IniesRecordContextProvider from "../core/context/IniesContext"
import { RseeDocumentContextProvider } from "../core/context/beem-pilot/rsee/RseeDocumentContext"
import { RseeDocumentListContextProvider } from "../core/context/beem-pilot/rsee/RseeDocumentListContext"
import { BSModelContextProvider } from "../core/context/beem-shot/BSBimModel/BSBimModelContext"
import { BSModelListContextProvider } from "../core/context/beem-shot/BSBimModel/BSBimModelContextList"
import { BSModelFileContextProvider } from "../core/context/beem-shot/BSBimModel/BSBimModelFileContext"
import { BSCategoriesContextProvider } from "../core/context/beem-shot/BSCategory/BSCategoriesContext"
import { BSCodesExtraitsContextProvider } from "../core/context/beem-shot/BSCodeExtrait/BSCodesExtraitsContext"
import { BSItemContextProvider } from "../core/context/beem-shot/BSItems/BSItemContext"
import { BSVariantContextProvider } from "../core/context/beem-shot/BSVariant/BSVariantContext"
import { BSVariantListContextProvider } from "../core/context/beem-shot/BSVariant/BSVariantListContext"
import BimModelContextProvider from "../core/context/bim-model/bim-model-context"
import BimModelFileContextProvider from "../core/context/bim-model/bim-model-file-context"
import { BimModelImportContextProvider } from "../core/context/bim-model/bim-model-import-context"
import CalculationCarbonAdditionalDataProvider from "../core/context/calculation/calculation-carbon-additional-data"
import CalculationCarbonExtractedDataProvider from "../core/context/calculation/calculation-carbon-extracted-data"
import CalculationCarbonFlateRateProvider from "../core/context/calculation/calculation-carbon-flate-rate-data"
import CalculationCarbonInformationProjectContextProvider from "../core/context/calculation/calculation-carbon-information-project"
import CalculationCarbonMaterialFilterContextProvider from "../core/context/calculation/calculation-carbon-material-filter-context"
import CalculationContextProvider from "../core/context/calculation/calculation-context"
import { CodeReferenceContextProvider } from "../core/context/code-acv/CodeReferenceContext"
import CodeAcvCompletionContextProvider from "../core/context/code-acv/code-acv-completion-context"
import CodeCustomContextProvider from "../core/context/code-acv/code-custom-context"
import CodesCompletionsContextProvider from "../core/context/code-acv/codes-completions-context"
import CodesExtraitsListContextProvider from "../core/context/code-acv/codes-extraits-list-context"
import { LotContextProvider } from "../core/context/lot-context"
import MaterialLibContextProvider from "../core/context/material/material-lib-context"
import MaterialLibDeclarationTypeContextProvider from "../core/context/material/material-lib-declaration-type-context"
import { MaterialLibFilterContextProvider } from "../core/context/material/material-lib-filter-context"
import MaterialLibOrganizationIndicatorContextProvider from "../core/context/material/material-lib-organization-indicator-context"
import { MaterialLibProjectIndicatorContextProvider } from "../core/context/material/material-lib-project-indicator-context"
import MaterialLibSearchContextProvider from "../core/context/material/material-lib-search-context"
import { NavBarContextProvider } from "../core/context/nav-bar/AppNavBarContext"
import AdminOrganizationContextProvider from "../core/context/organization/admin-organization-context"
import DomainNameValidatorContextProvider from "../core/context/organization/domain-name-validator-context"
import { OrganizationContextProvider } from "../core/context/organization/organization-context"
import OrganizationsListContextProvider from "../core/context/organization/organization-list-context"
import ProjectMaterialContextProvider from "../core/context/project-material-context"
import { CoverImgProjectContextProvider } from "../core/context/project/CoverImgProjectContext"
import { ProjectContextProvider } from "../core/context/project/ProjectContext"
import { ProjectListContextProvider } from "../core/context/project/ProjectListContext"
import SelectedPhaseProvider from "../core/context/selected-phase-context"
import TutorialEnabledContextProvider from "../core/context/tutoriel-enabled-context"
import ProjectRoleContextProvider from "../core/context/user/project-role-context"
import { V0BMProjectContextProvider } from "../core/context/v0-bm-project/V0BMProjectContext"
import ProjectTypeContextProvider from "../core/context/v0-bm-project/project-type-context"
import VariantContextProvider from "../core/context/variant-context"
import { CodesVersion } from "../core/enum/codesVersionEnum"
import { getEnvProperty, PROPERTIES } from "../core/services/environment-service"
import { AccountPage } from "../pages/account-page/account-page"
import { adminMenu } from "../pages/admin-page/admin-menu"
import { OrganizationPage } from "../pages/admin-page/organization/OrganizationPage"
import BimProjectOrganizationPage from "../pages/admin-page/organization/bim-project-organization-page"
import OrganizationList from "../pages/admin-page/organization/organization-list"
import RseeProjectOrganizationPage from "../pages/admin-page/organization/rsee-project-organization-page"
import UserTableOrganizationPage from "../pages/admin-page/organization/user-table-organization-page"
import AdminStatistics from "../pages/admin-page/statistics/admin-statistics"
import AdminInviteUserForm from "../pages/admin-page/user/admin-invite-user-form"
import AdminUpdateUserForm from "../pages/admin-page/user/admin-update-user-form"
import { ConfirmPage } from "../pages/authentication/ConfirmPage/ConfirmPage"
import { ForgotPasswordPage } from "../pages/authentication/forgot-password-page/ForgotPasswordPage"
import SignInPage from "../pages/authentication/SignInPage/SignInPage"
import SignUpPage from "../pages/authentication/sign-up-page/sign-up-page"
import SignUpTestUserPage from "../pages/authentication/sign-up-test-user-page/sign-up-test-user-page"
import BeemGuideExcelAcceptPage from "../pages/beem-guide-excel-page/beem-guide-excel-accept-page"
import BeemGuideExcelPage from "../pages/beem-guide-excel-page/beem-guide-excel-page"
import { GlobalRseeDashboardPage } from "../pages/global-rsee-dashboard/GlobalRseeDashboardPage"
import { HomePage } from "../pages/home-page/HomePage"
import { KairnialDashboardPage } from "../pages/kairnial/KairnialDashboardPage"
import { MyOrganization } from "../pages/my-organization-page/MyOrganization"
import { NoMatch } from "../pages/no-match/no-match"
import { MyOfferPage } from "../pages/offer/MyOfferPage"
import { ProjectsHomePage } from "../pages/projects/ProjectsHomePage"
import { ProjectOverviewPage } from "../pages/projects/project/ProjectOverviewPage"
import { BSBuildingContextProvider } from "../pages/projects/project/beem-shot/variant/building/components/context/BSBuildingContext"
import { BSBuildingListContextProvider } from "../pages/projects/project/beem-shot/variant/building/components/context/BSBuildingListContext"
import { BSBimModelDetailPage } from "../pages/projects/project/tabs/BimModelTab/BSBimModelDetailPage/BSBimModelDetailPage"
import { BSBimModelImportPage } from "../pages/projects/project/tabs/BimModelTab/BSBimModelImportPage/BSBimModelImportPage"
import { ProgressBarContextProvider } from "../pages/projects/project/tabs/BimPilotTab/components/RseeDocumentDashboardPage/context/ProgressBarContext"
import { TeamContextProvider } from "../pages/projects/project/tabs/TeamTab/context/TeamContext"
import { ConfigurationHelperPage } from "../pages/support/ConfigurationHelperPage"
import { HelperCenterPage } from "../pages/support/HelpCenterPage"
import { TutorialHelperPage } from "../pages/support/TutorialHelperPage"
import { BimModelUploadPage } from "../pages/v0-project-page/bim-model/bim-model-upload-page/bim-model-upload-page"
import GeneralInformationPage from "../pages/v0-project-page/calculation"
import { AdditionalCodePage } from "../pages/v0-project-page/calculation/additional-code-page/additional-code-page"
import { ExtractedCodePage } from "../pages/v0-project-page/calculation/extracted-code-page/extracted-code-page"
import FlateRatesPage from "../pages/v0-project-page/calculation/flate-rates-page/flate-rates-page"
import WorksitePage from "../pages/v0-project-page/calculation/worksite-page"
import ProjectControlBoard from "../pages/v0-project-page/control-board"
import DashboardsPage from "../pages/v0-project-page/dashboard/dashboard-page"
import ProjectForm from "../pages/v0-project-page/project-info/project-form"
import ProjectMaterialLibPage from "../pages/v0-project-page/project-material-lib/project-material-lib-page"
import { TeamPage } from "../pages/v0-project-page/team-page/team-page"
import { BSRoutes } from "./BSRouter"
import { RseeRoutes } from "./RseeRouter"
import { TableauExtensionsRoutes } from "./TableauExtensionsRouter"

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <ProjectTypeContextProvider>
          <Outlet />
        </ProjectTypeContextProvider>
      }>
      {/* Not authenticated user */}
      {TableauExtensionsRoutes}

      <Route path={pagesUrl.KAIRNIAL_DASHBOARD} element={<KairnialDashboardPage />} />
      <Route
        element={
          <RequireNoAuth>
            <Outlet />
          </RequireNoAuth>
        }>
        <Route path="/" element={<SignInPage />} />
        <Route path={pagesUrl.SIGN_IN_PAGE} element={<SignInPage />} />
        <Route path={pagesUrl.SIGN_UP_INVITATION_PAGE} element={<SignUpPage />} />
        <Route
          path={pagesUrl.SIGN_UP_PAGE}
          element={
            <GoogleReCaptchaContextProvider reCaptchaKey={getEnvProperty(PROPERTIES.REACT_APP_RECAPTCHA_SITE_KEY)}>
              <DomainNameValidatorContextProvider>
                <SignUpTestUserPage />
              </DomainNameValidatorContextProvider>
            </GoogleReCaptchaContextProvider>
          }
        />
        <Route path={pagesUrl.FORGOT_PWD_PAGE} element={<ForgotPasswordPage />} />
        <Route path={pagesUrl.CONFIRM_PAGE} element={<ConfirmPage />} />
        <Route path={pagesUrl.BEEM_GUIDE_EXCEL} element={<BeemGuideExcelPage />} />
        <Route path={pagesUrl.BEEM_GUIDE_EXCEL_ACCEPT} element={<BeemGuideExcelAcceptPage />} />
      </Route>
      {/* End not authenticated user */}

      <Route
        element={
          <RequireAuth>
            <ProgressBarContextProvider>
              <OrganizationContextProvider>
                <AppSideBarContextProvider>
                  <DepartmentContextProvider>
                    <ProjectListContextProvider>
                      <ProjectContextProvider>
                        <NavBarContextProvider>
                          <BSModelListContextProvider>
                            <RseeDocumentListContextProvider>
                              <CoverImgProjectContextProvider>
                                <BSVariantListContextProvider>
                                  <BSVariantContextProvider>
                                    <BSBuildingListContextProvider>
                                      <BSBuildingContextProvider>
                                        <TeamContextProvider>
                                          <NotificationContextProvider>
                                            <BSLayout />
                                          </NotificationContextProvider>
                                        </TeamContextProvider>
                                      </BSBuildingContextProvider>
                                    </BSBuildingListContextProvider>
                                  </BSVariantContextProvider>
                                </BSVariantListContextProvider>
                              </CoverImgProjectContextProvider>
                            </RseeDocumentListContextProvider>
                          </BSModelListContextProvider>
                        </NavBarContextProvider>
                      </ProjectContextProvider>
                    </ProjectListContextProvider>
                  </DepartmentContextProvider>
                </AppSideBarContextProvider>
              </OrganizationContextProvider>
            </ProgressBarContextProvider>
          </RequireAuth>
        }>
        <Route path={pagesUrl.HOME} element={<HomePage />} />

        <Route path={pagesUrl.PROJECTS_PAGE} element={<ProjectsHomePage />} />

        <Route path={pagesUrl.GLOBAL_RSEE_DASHBOARD} element={<GlobalRseeDashboardPage />} />

        {RseeRoutes}
        {BSRoutes}
        <Route
          element={
            <BSCategoriesContextProvider>
              <BSModelContextProvider>
                <Outlet />
              </BSModelContextProvider>
            </BSCategoriesContextProvider>
          }>
          <Route path={pagesUrl.PROJECT_PAGE_DETAIL} element={<ProjectOverviewPage />} />
          <Route
            element={
              <BSModelFileContextProvider>
                <BSItemContextProvider>
                  <BSCodesExtraitsContextProvider>
                    <Outlet />
                  </BSCodesExtraitsContextProvider>
                </BSItemContextProvider>
              </BSModelFileContextProvider>
            }>
            <Route path={pagesUrl.BIM_MODEL_IMPORT_PAGE} element={<BSBimModelImportPage />} />
            <Route path={pagesUrl.BIM_MODEL_DETAIL_PAGE} element={<BSBimModelDetailPage />} />
          </Route>
        </Route>

        {/* User account */}
        <Route path={pagesUrl.ACCOUNT_PAGE} element={<AccountPage />} />
        <Route path={pagesUrl.MY_OFFER_PAGE} element={<MyOfferPage />} />
        <Route
          path={pagesUrl.MY_ORGANIZATION_PAGE}
          element={
            <DomainNameValidatorContextProvider>
              <MyOrganization />
            </DomainNameValidatorContextProvider>
          }
        />
        <Route path={pagesUrl.BEEM_SHOT_HELP_CENTER} element={<HelperCenterPage />} />
        <Route path={pagesUrl.BEEM_SHOT_CONFIGURATION_HELPER} element={<ConfigurationHelperPage />} />
        <Route
          path={pagesUrl.BEEM_SHOT_TUTORIAL_HELPER}
          element={
            <BSCategoriesContextProvider>
              <CodeReferenceContextProvider projectCodeVersion={CodesVersion.VERSION_1_6}>
                <TutorialHelperPage />
              </CodeReferenceContextProvider>
            </BSCategoriesContextProvider>
          }
        />
        {/* End user account */}
      </Route>

      {/* Admin/Ultimate user part */}
      <Route
        path={adminPagesUrl.ADMIN}
        element={
          <RequireAuthUltimate>
            <OrganizationsListContextProvider>
              <AdminOrganizationContextProvider>
                <DomainNameValidatorContextProvider>
                  <Layout mainMenu={adminMenu} />
                </DomainNameValidatorContextProvider>
              </AdminOrganizationContextProvider>
            </OrganizationsListContextProvider>
          </RequireAuthUltimate>
        }>
        <Route path={adminPagesUrl.ADMIN_ORGANIZATION_LIST_PAGE} element={<OrganizationList />} />
        <Route path={adminPagesUrl.ADMIN_ORGANIZATION_USER_PAGE} element={<AdminUpdateUserForm />} />
        {/*<Route path={adminPagesUrl.ADMIN_INVITED_USERS_LIST_PAGE} element={<TestUsersList />} />*/}
        <Route path={adminPagesUrl.ADMIN_SUMMARY} element={<AdminStatistics />} />

        <Route
          element={
            <RequireAuthUltimate>
              <AdminOrganizationContextProvider>
                <LayoutAdmin />
              </AdminOrganizationContextProvider>
            </RequireAuthUltimate>
          }>
          {/*Detail of an organization */}
          <Route path={adminPagesUrl.ADMIN_ORGANIZATION_PAGE} element={<OrganizationPage />} />

          {/* admin Detail of the users in an organization */}
          <Route
            path={adminPagesUrl.ADMIN_USER_ORGANIZATION_PAGE}
            element={
              <DomainNameValidatorContextProvider>
                <UserTableOrganizationPage />
              </DomainNameValidatorContextProvider>
            }
          />

          {/* admin RSEE project */}
          <Route path={adminPagesUrl.ADMIN_PROJECT_RSEE_PAGE} element={<RseeProjectOrganizationPage />} />

          <Route path={adminPagesUrl.ADMIN_RSEE_PROJECT} element={<Outlet />}>
            <Route
              path={adminPagesUrl.ADMIN_RSEE_PROJECT_DOCUMENT}
              element={
                <RseeDocumentContextProvider>
                  <Outlet />
                </RseeDocumentContextProvider>
              }
            />
          </Route>
          {/* End rsee project*/}

          <Route
            path={`${adminPagesUrl.ADMIN_ORGANIZATION_INVITE_USER_PAGE}`}
            element={
              <RequireOrganization>
                <DomainNameValidatorContextProvider>
                  <AdminInviteUserForm />
                </DomainNameValidatorContextProvider>
              </RequireOrganization>
            }
          />
          <Route path={`${adminPagesUrl.ADMIN_ORGANIZATION_INVITE_FIRST_MEGA_USER}`} element={<AdminInviteUserForm />} />
          <Route
            path={`${adminPagesUrl.ADMIN_ORGANIZATION_INVITE_FIRST_MEGA_USER}`}
            element={
              <RequireOrganization>
                <DomainNameValidatorContextProvider>
                  <AdminInviteUserForm />
                </DomainNameValidatorContextProvider>
              </RequireOrganization>
            }
          />

          {/* admin Management BIM Project */}
          <Route path={adminPagesUrl.ADMIN_BIM_PROJECT_PAGE} element={<BimProjectOrganizationPage />} />
          <Route
            path={`${adminPagesUrl.ADMIN_BIM_PROJECT_PAGE}/:projectId`}
            element={
              <LotContextProvider>
                <V0BMProjectContextProvider>
                  <ProjectRoleContextProvider>
                    <SelectedPhaseProvider>
                      <BimModelContextProvider>
                        <BimModelFileContextProvider>
                          <TutorialEnabledContextProvider>
                            <CalculationContextProvider>
                              <VariantContextProvider>
                                <Outlet />
                              </VariantContextProvider>
                            </CalculationContextProvider>
                          </TutorialEnabledContextProvider>
                        </BimModelFileContextProvider>
                      </BimModelContextProvider>
                    </SelectedPhaseProvider>
                  </ProjectRoleContextProvider>
                </V0BMProjectContextProvider>
              </LotContextProvider>
            }>
            <Route path={adminPagesUrl.ADMIN_PROJECT_CONTROL_BOARD} element={<ProjectControlBoard />} />
            <Route path={adminPagesUrl.ADMIN_PROJECT_INFO} element={<ProjectForm />} />
            <Route path={adminPagesUrl.ADMIN_PROJECT_TEAM_MANAGEMENT} element={<TeamPage />} />

            {/* admin project material lib */}
            <Route
              path={adminPagesUrl.ADMIN_PROJECT_MATERIAL_PAGE}
              element={
                <MaterialLibFilterContextProvider>
                  <MaterialLibSearchContextProvider>
                    <MaterialLibContextProvider>
                      <IniesRecordContextProvider>
                        <MaterialLibOrganizationIndicatorContextProvider>
                          <MaterialLibProjectIndicatorContextProvider>
                            <MaterialLibDeclarationTypeContextProvider>
                              <ProjectMaterialLibPage />
                            </MaterialLibDeclarationTypeContextProvider>
                          </MaterialLibProjectIndicatorContextProvider>
                        </MaterialLibOrganizationIndicatorContextProvider>
                      </IniesRecordContextProvider>
                    </MaterialLibContextProvider>
                  </MaterialLibSearchContextProvider>
                </MaterialLibFilterContextProvider>
              }
            />
            {/* End admin project material lib */}
            {/* bim model */}
            <Route
              path={`${adminPagesUrl.ADMIN_BIM_PROJECT_PAGE}/:projectId/bim-model`}
              element={
                <BimModelImportContextProvider>
                  <Outlet />
                </BimModelImportContextProvider>
              }>
              <Route path={adminPagesUrl.ADMIN_PROJECT_BIM_MODEL_IMPORT} element={<BimModelUploadPage />} />
            </Route>
            {/* End bim model */}

            {/* Calculation */}
            <Route
              path={adminPagesUrl.ADMIN_PROJECT_CALCULATION_CORE_DATA}
              element={
                <CodesExtraitsListContextProvider>
                  <CodesCompletionsContextProvider>
                    <CalculationCarbonMaterialFilterContextProvider>
                      <CodeAcvCompletionContextProvider>
                        <CodeCustomContextProvider>
                          <CalculationCarbonExtractedDataProvider>
                            <CalculationCarbonAdditionalDataProvider>
                              <MaterialLibFilterContextProvider>
                                <MaterialLibSearchContextProvider>
                                  <MaterialLibContextProvider>
                                    <IniesRecordContextProvider>
                                      <ProjectMaterialContextProvider>
                                        <Outlet />
                                      </ProjectMaterialContextProvider>
                                    </IniesRecordContextProvider>
                                  </MaterialLibContextProvider>
                                </MaterialLibSearchContextProvider>
                              </MaterialLibFilterContextProvider>
                            </CalculationCarbonAdditionalDataProvider>
                          </CalculationCarbonExtractedDataProvider>
                        </CodeCustomContextProvider>
                      </CodeAcvCompletionContextProvider>
                    </CalculationCarbonMaterialFilterContextProvider>
                  </CodesCompletionsContextProvider>
                </CodesExtraitsListContextProvider>
              }>
              <Route
                path={adminPagesUrl.ADMIN_PROJECT_CALCULATION_CORE_DATA}
                element={
                  <CalculationCarbonInformationProjectContextProvider>
                    <GeneralInformationPage />
                  </CalculationCarbonInformationProjectContextProvider>
                }
              />
              <Route
                path={adminPagesUrl.ADMIN_PROJECT_CALCULATION_FLAT_RATES}
                element={
                  <CalculationCarbonFlateRateProvider>
                    <FlateRatesPage />
                  </CalculationCarbonFlateRateProvider>
                }
              />
              <Route path={adminPagesUrl.ADMIN_PROJECT_CALCULATION_EXTRACTED_DATA} element={<ExtractedCodePage />} />
              <Route path={adminPagesUrl.ADMIN_PROJECT_CALCULATION_ADDITIONAL_DATA} element={<AdditionalCodePage />} />
              <Route path={adminPagesUrl.ADMIN_PROJECT_CALCULATION_WORKSITE} element={<WorksitePage />} />
            </Route>
            {/* End Calculation */}

            {/* Dashboard */}
            <Route
              path={adminPagesUrl.ADMIN_PROJECT_DASHBOARD}
              element={
                <CodesExtraitsListContextProvider>
                  <Outlet />
                </CodesExtraitsListContextProvider>
              }>
              <Route path={adminPagesUrl.ADMIN_PROJECT_DASHBOARD_TABLEAU} element={<DashboardsPage />} />
            </Route>
          </Route>
          {/* End Dashboard */}
        </Route>
      </Route>
      {/* End admin/Ultimate user part*/}
      <Route path="*" element={<NoMatch />} />
    </Route>
  )
)

export function AppRouter(): React.JSX.Element {
  return <RouterProvider router={router} />
}
